/**
 * Created JS
 * User: JiangYilong
 * Date: 2018/7/26
 * Time: 11:26
 * Email: jiangyilong@wafersystems.com
 */
import React from 'react';
import { FormattedMessage } from 'react-intl';
import { Button, Col, Radio, Row } from 'antd';
import logoImg from '../../assets/bg_vsk.png';
import ScanImg from '../../assets/code_vsk.jpg';
import { isPC } from '../../utils/common';
import { RES_STATUS } from '../../utils/constants';
// import styles from './Index.less';

require('./Index.less');

const RadioGroup = Radio.Group;

class Index extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      value: 1,
      delayResult: false
    };
    this.onChange = this.onChange.bind(this);
  }

  onChange = e => {
    this.props.dispatch({
      type: 'account/setDelayTime',
      delayTime: e.target.value
    });
  };

  render() {
    let hostUrl = String(window.location.host).toLowerCase();
    let clsName = isPC() ? 'pc-body' : 'mobile-body';

    const {
      delayTime = 30,
      delayTimeInfor,
      delayMeetingInfor,
      delayMsg,
      delayStatus,
      maxDelayTime=""
    } = this.props.account;
    const delayBlock = [];
    if(maxDelayTime) {
      const delayArray = maxDelayTime.split("|");
      delayArray.map((time, i)=>{
        delayBlock.push(<Radio key={i} value={time}><FormattedMessage id="delay_meeting_select_time" values={{ time }}/></Radio>)
      });
    }
    const meetingCircle =
      delayMeetingInfor.type > 0
        ? delayMeetingInfor.capacity == 1
          ? '4'
          : '2'
        : 1 == delayMeetingInfor.capacity
          ? '3'
          : '1';

    const getDelayBtn = () => {
      if(delayMsg){
        if(RES_STATUS === delayStatus === RES_STATUS.success){
          return <Button
            onClick={() => {
              this.props.dispatch({
                type: 'account/setDelayMsg',
                delayMsg: ''
              });
            }}
          >
            <FormattedMessage id="continue_extend" />
          </Button>;
        } else {//延长失败时，不再显示继续延长按钮
          return "";
        }
      } else {
        return <Button
          onClick={() => {
            this.props.dispatch({
              type: 'account/delayMeeting',
              params: {
                delayTime: delayTime
              }
            });
          }}
        >
          <FormattedMessage id="index_submit" />
        </Button>;
      }
    };

    return (
      <div className={clsName}>
        <div className="empty" />
        <div className="main">
          <div className="logo">
            <div className="logo-img">
              <img src={delayMeetingInfor.emailTitleLogo || logoImg} alt="" />
            </div>
          </div>
          <div className="header">
            <div className="title"><FormattedMessage id="extend_meeting" /></div>
            <div className="choose">
              <Row>
                {
                  delayMsg ?
                    <Col span={16}>{delayMsg}</Col> :
                    <Col span={16}>
                    <RadioGroup onChange={this.onChange} value={delayTime}>
                      {delayBlock}
                    </RadioGroup>
                  </Col>
                }
                <Col span={8} className="btn">
                  {getDelayBtn()}
                </Col>
              </Row>
            </div>
          </div>
          <div className="content">
            <Row className="row">
              <Col className="title" span={6}>
                <FormattedMessage id="main_meeting_title" />:
              </Col>
              <Col className="title-con" span={18}>
                {delayMeetingInfor.name}
              </Col>
            </Row>
            <Row className="row">
              <Col className="title" span={6}>
                <FormattedMessage id="main_meeting_room" />:{' '}
              </Col>
              <Col className="title-con" span={18}>
                {this.props.intl.locale === 'en_US'?delayMeetingInfor.roomNamesEn:delayMeetingInfor.roomNames}
              </Col>
            </Row>
            <Row className="row">
              <Col className="title" span={6}>
                <FormattedMessage id="meeting_list_table_start" />:{' '}
              </Col>
              <Col className="title-con" span={18}>
                {delayMeetingInfor.showStartTime}
              </Col>
            </Row>
            <Row className="row">
              <Col className="title" span={6}>
                <FormattedMessage id="meeting_list_table_end" />:{' '}
              </Col>
              <Col className="title-con" span={18}>
                {delayMeetingInfor.showEndTime}
              </Col>
            </Row>
            <Row className="row">
              <Col className="title" span={6}>
                <FormattedMessage id="meeting_reserve_message_mail_webex_creator" />:{' '}
              </Col>
              <Col className="title-con" span={18}>
                {delayMeetingInfor.creator}
              </Col>
            </Row>
            <Row className="row">
              <Col className="title" span={6}>
                <FormattedMessage id="meeting_reserve_message_mail_webex_holder" />:{' '}
              </Col>
              <Col className="title-con" span={18}>
                {delayMeetingInfor.holder}
              </Col>
            </Row>
            <Row className="row">
              <Col className="title" span={6}>
                <FormattedMessage id="meeting_reserve_message_mail_webex_users" />:{' '}
              </Col>
              <Col className="title-con" span={18}>
                {delayMeetingInfor.memberNames}
              </Col>
            </Row>
            {/*<Row className='row'>*/}
            {/*<Col className='title' span={6}>会议说明: </Col>*/}
            {/*<Col className='title-con' span={18}>{delayMeetingInfor.creator}</Col>*/}
            {/*</Row>*/}
            <Row className="row">
              <Col className="title" span={6}>
                <FormattedMessage id="delay_meeting_loop_recurrence" />:{' '}
              </Col>
              <Col className="title-con" span={18}>
                {meetingCircle == 1
                  ? this.props.intl.formatMessage({ id: 'main_meeting_cmma_normal' })
                  : meetingCircle == 2
                    ? this.props.intl.formatMessage({ id: 'loop_meeting' })
                    : meetingCircle == 3
                      ? 'webex'
                      : 'webex ' + this.props.intl.formatMessage({ id: 'loop_meeting' })}
              </Col>
            </Row>
            <Row className="row-end">
              <Col className="title-end" span={24}>
                <FormattedMessage id="delay_meeting_wish_tip" />
              </Col>
            </Row>
          </div>
        </div>
        {hostUrl.indexOf('wafer') > -1 || hostUrl.indexOf('virsical') > -1 ? (
          <div className="footer">
            <Row className={'row'}>
              <Col className="infor" span={18}>
                <div className="com"><FormattedMessage id="delay_meeting_bottom_wafer" /></div>
                <div className="phone"><FormattedMessage id="index_bottom_28" /></div>
              </Col>
              <Col className="img" span={6}>
                <img src={ScanImg} alt="" />
              </Col>
            </Row>
          </div>
        ) : null}
      </div>
    );
  }
}

export default Index;



// WEBPACK FOOTER //
// ./src/components/delay/index.js